export default __webpack_public_path__ + "static/media/reingresso.be46723f.png";